import { useState } from "react";
import { ReviewImageThumbnails } from "./ReviewImageThumbnails";
import { ReviewDisplayModal } from "./ReviewDisplayModal";

interface ReviewImageGalleryProps {
  images: string[];
  reviewText?: string;
  reviewRating?: number;
  reviewerName?: string;
}

export const ReviewImageGallery = ({ 
  images,
  reviewText,
  reviewRating,
  reviewerName
}: ReviewImageGalleryProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!images || images.length === 0) return null;

  const openModal = (index: number) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  return (
    <>
      <ReviewImageThumbnails 
        images={images}
        onImageClick={openModal}
      />
      
      <ReviewDisplayModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        images={images}
        reviewText={reviewText}
        reviewRating={reviewRating}
        reviewerName={reviewerName}
      />
    </>
  );
};